import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { configuracionService } from '../services/api';
import ConfirmPopup from '../components/ConfirmPopup';
import './Dashboard.css';
import './PlantillasMail.css';

const MENSAJE_DEFAULT = 'Temporalmente el registro se encuentra deshabilitado';

const BloquearRegistro = () => {
  const navigate = useNavigate();
  const [registroHabilitado, setRegistroHabilitado] = useState(true);
  const [mensaje, setMensaje] = useState(MENSAJE_DEFAULT);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    configuracionService
      .getRegistroConfig()
      .then((data) => {
        if (!cancelled) {
          setRegistroHabilitado(data.registro_habilitado !== false);
          setMensaje(data.mensaje_registro_deshabilitado || MENSAJE_DEFAULT);
        }
      })
      .catch(() => {
        if (!cancelled) setError('Error al cargar la configuración.');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  const handleSave = async () => {
    setSaving(true);
    setMessage({ type: '', text: '' });
    setError('');
    try {
      await configuracionService.updateRegistroConfig({
        registro_habilitado: registroHabilitado,
        mensaje_registro_deshabilitado: mensaje || MENSAJE_DEFAULT,
      });
      setMessage({ type: 'success', text: 'Configuración guardada.' });
    } catch (err) {
      setMessage({ type: 'error', text: err.response?.data?.error || 'No se pudo guardar.' });
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="dashboard-header plantillas-mail-header">
        <button type="button" className="plantillas-mail-back" onClick={() => navigate('/dashboard/configuracion')}>
          ← Volver a Configuración
        </button>
        <h1>Bloquear registro</h1>
        <p>Cargando...</p>
      </div>
    );
  }

  return (
    <>
      <div className="dashboard-header plantillas-mail-header">
        <button
          type="button"
          className="plantillas-mail-back"
          onClick={() => navigate('/dashboard/configuracion')}
          aria-label="Volver a Configuración"
        >
          ← Volver a Configuración
        </button>
        <h1>Bloquear registro</h1>
        <p>Si desactivas el registro, los usuarios no podrán acceder a /register y verán el mensaje que configures.</p>
      </div>

      <ConfirmPopup
        open={Boolean(error) || (Boolean(message.text) && message.type === 'error')}
        title="Error"
        message={error || message.text}
        confirmLabel="Aceptar"
        cancelLabel={null}
        onConfirm={() => { setError(''); setMessage({ text: '', type: '' }); }}
        onCancel={() => { setError(''); setMessage({ text: '', type: '' }); }}
        variant="danger"
      />
      {message.text && message.type !== 'error' && (
        <div className="dashboard-inscripcion-msg dashboard-inscripcion-ok">
          {message.text}
        </div>
      )}

      <section className="dashboard-section">
        <div className="bloquear-registro-card">
          <div className="bloquear-registro-field">
            <label className="bloquear-registro-label">
              <input
                type="checkbox"
                checked={registroHabilitado}
                onChange={(e) => setRegistroHabilitado(e.target.checked)}
                disabled={saving}
              />
              <span>Registro habilitado</span>
            </label>
            <p className="bloquear-registro-help">
              Si está desmarcado, nadie podrá abrir la página de registro y verá el mensaje de abajo.
            </p>
          </div>
          <div className="bloquear-registro-field">
            <label htmlFor="bloquear-registro-mensaje" className="bloquear-registro-label-text">
              Mensaje cuando el registro está deshabilitado
            </label>
            <textarea
              id="bloquear-registro-mensaje"
              className="bloquear-registro-textarea"
              rows={4}
              value={mensaje}
              onChange={(e) => setMensaje(e.target.value)}
              placeholder={MENSAJE_DEFAULT}
              disabled={saving}
            />
          </div>
          <div className="bloquear-registro-actions">
            <button
              type="button"
              className="usuarios-btn usuarios-btn-primary"
              disabled={saving}
              onClick={handleSave}
            >
              {saving ? 'Guardando...' : 'Guardar'}
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default BloquearRegistro;
